namespace TabAurous.Production {
    export namespace JobWorkReceiptItemsService {
        export const baseUrl = 'Production/JobWorkReceiptItems';

        export declare function Update(request: Serenity.SaveRequest<JobWorkReceiptItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<JobWorkReceiptItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<JobWorkReceiptItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Update = "Production/JobWorkReceiptItems/Update",
            Delete = "Production/JobWorkReceiptItems/Delete",
            Retrieve = "Production/JobWorkReceiptItems/Retrieve",
            List = "Production/JobWorkReceiptItems/List"
        }

        [
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>JobWorkReceiptItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
